import React, { useEffect, useState } from "react";
import axios from "axios";

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  desc: string;
  date: string;
}

const Home = () => {
  const api = process.env.REACT_APP_API_URL as string;

  const [headlines, setHeadlines] = useState<string[]>([]);

  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // const headlines = [
  //   "4 held for Rs 10 crore extortion bid using Bishnoi Gang’s name in Jpr",
  //   "RCB victory parade ends in stampede",
  //   "Weather alert: Monsoon enters Kerala",
  //   "PM Modi chairs 5-hour meet with ministers",
  // ];



  const [index, setIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(`${api}/auth/news`);
        const titles = response.data.map((item) => item.title); // assuming `title` exists in NewsStructure
      setHeadlines(titles);
        setNewData(response.data);
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch news");
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % headlines.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prevIndex) => (prevIndex + 1) % newData.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [newData.length]);


  const getVisibleItems = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      visible.push(newData[(startIndex + i) % newData.length]);
    }
    return visible;
  };

  const today = new Date();
  const formattedDate = `${today.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
  })}-${today.getFullYear()} ${today.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })}`;

  if (loading) return <div className="text-center mt-10 text-xl">Loading news...</div>;
  if (error) return <div className="text-center mt-10 text-red-600">{error}</div>;

  return (
    <div>
      {/* Latest News Bar */}
      <div className="mx-auto mt-2 ml-3 w-[95%] sm:w-[90%] md:w-[80%] lg:w-[73%] px-2">
        <div className="bg-blue-800 text-blue-100 rounded-md flex items-center px-4 py-3 overflow-hidden">
          <span className="font-bold mr-4">LATEST NEWS</span>
          <div className="h-8 border-l-2 border-red-500"></div>
          <p className="whitespace-nowrap transition-all duration-500 ml-10 text-lg">
            {headlines[index]}
          </p>
        </div>
      </div>

      {/* Main News Section */}
      <div className="w-full flex flex-col lg:flex-row gap-4 lg:gap-8 px-2 sm:px-4 py-4">
        {/* Featured News & Slider */}
        <div className="w-full lg:w-[75%] space-y-4 h-[100%]">
        
{newData.length > 0 && (
  <div className="bg-pink-600 text-white p-4 rounded shadow-sm grid grid-cols-1 md:grid-cols-2 gap-4 h-auto md:h-[50vh] cursor-pointer" 
   onClick={()=>{
      window.location.href = `/news/${newData[0].id}`
    }}
  >
    <img
      // src={newData[0].img}
      src={`${api}/${newData[0].img}`} 
      alt={newData[0].title}
      className="w-full h-[290px] object-cover rounded"
    />
    <div>
      <h2 className="font-bold text-3xl mb-2">{newData[0].title}</h2>
      <p className="text-xl">{newData[0].desc}</p>
      <p className="text-lg mt-2">
        By: FirstIndia | <span className="ml-3">{formattedDate}</span>
      </p>
    </div>
  </div>
)}


         

          {/* News Cards Slider */}
          <div className="bg-pink-600 p-4 overflow-hidden">
  <div className="transition-transform duration-700 ease-in-out grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
   {getVisibleItems().map((item) => (
  <div
    key={item.id}
    className="bg-pink-600 text-white flex items-center gap-4 p-2 rounded shadow hover:bg-pink-700 transition cursor-pointer"
    onClick={()=>{
      window.location.href = `/news/${item.id}`
    }}
  >
    <img
      src={`${api}/${item.img}`}
      alt={item.title || 'Item image'}
      className="w-20 h-20 object-cover rounded"
      onError={(e) => (e.currentTarget.src = '/fallback.png')}
    />
    <p className="text-2xl font-semibold">{item.title}</p>
    
  </div>
))}

  </div>
</div>

        </div>

        {/* Newspaper Image */}

        {newData.length > 0 && (
<div className="w-full lg:w-[25%] mt-6 lg:mt-[-72px] px-2">
          <a href={`news/${newData[0].title}`} target="_blank" rel="noopener noreferrer">
            <img
              src={`${api}/${newData[0].img}`}
              alt="newspaper"
              className="w-full cursor-pointer rounded shadow-md"
            />
          </a>
        </div>
)}
      </div>
    </div>
  );
};

export default Home;
